export class WebAlertStatistics {
    constructor(data) {
        this.statisticsdate = data.statisticsdate;
        this.count = data.count || 0;
        this.booking = data.booking || 0;
        this.cargps = data.cargps || 0;
        this.dirorder = data.dirorder || 0;
    }
}
